export default __webpack_public_path__ + "static/media/bookmark-icon.35adc5e0.svg";